<template>
    <div class="modal-content m-modalPromoAccept">
        <div class="modal-contentWrap">
            <div class="modal-header bg-1">
                <modal-close :confirmation="confirmationWindowConfig" />
                <div class="modal-title mb-0 mb-md-2">
                    <h2 class="h3 mb-0">
                        {{ headerTitle }}
                    </h2>
                </div>

                <div v-if="filterSelectedMerchants.length">
                    Aktywacja w
                    {{
                        filterSelectedMerchants.length
                            | plurals('sklepie', 'sklepach')
                    }}
                    <span
                        class="cursor-pointer"
                        @click="
                            $store.dispatch('setFilter', {
                                filter: 'promo|subscription|merchant_id',
                                value: [],
                                moduleName: 'promotions'
                            })
                        "
                    >[wyczyść filtr]</span>
                </div>
            </div>
        </div>
        <div v-if="step === 1" class="modal-body p-0">
            <div class="richTable-body t-promos scrollbar is-docked">
                <div class="t-promo-groups w-100 px-2 px-xs-3 py-3">
                    <div class="a-infoBar a-infoBar--warning mb-3">
                        Decyzja o cenie w Promocji należy do Ciebie - kliknij
                        w przycisk „Pokaż promocje” i edytuj jej cenę. Tylko
                        cena ustalona przez Ciebie na poziomie nie wyższym niż
                        zaproponowana uprawnia do otrzymania Zwrotu Kosztów.
                    </div>
                    <div
                        class="t-promo-group promo-group d-flex flex-column"
                        v-for="group in promoGroups"
                        :key="`group-` + group.id"
                        :id="`group-${group.id}`"
                    >
                        <div
                            class="
                                m-modalPromoAccept__groupHeader
                                d-flex
                                justify-content-between
                                w-100
                                gap-1
                                align-items-center
                            "
                        >
                            <div class="t-promo-group__details ">
                                <h4>{{ group.name }}</h4>
                                <div class="text-primary font-weight-bold">
                                    do aktywacji wybrano
                                    <span class="text-dark">
                                        {{ group.selectedPromoIds.length }}
                                    </span>
                                    z
                                    <span class="text-dark">
                                        {{ group.countPromos }}
                                    </span>
                                    promocji
                                </div>
                            </div>
                            <div
                                class="
                                    t-promo-group__actions
                                    d-flex
                                    gap-0-5
                                    align-self-md-center
                                    flex-md-nowrap
                                    flex-wrap
                                "
                            >
                                <the-btn
                                    class="btn-custom-gray btn-block"
                                    :class="{
                                        'move-to-end':
                                            group.showMerchantsOnAcceptView
                                    }"
                                    @click.native="
                                        onShowHideMerchantsClick(group)
                                    "
                                >
                                    <a-icon
                                        :icon="
                                            group.showMerchantsOnAcceptView
                                                ? 'ArrowUp'
                                                : 'ArrowDown'
                                        "
                                        width="16px"
                                        class="mr-1"
                                    />
                                    Wybierz sklepy</the-btn>
                                <div class="d-flex gap-0-5 w-100">
                                    <the-btn
                                        class="
                                            m-modalPromoAccept__showPromosBtn
                                            btn-custom-gray
                                            btn-block
                                            mt-0
                                        "
                                        @click.native="
                                            onShowHidePromosClick(group)
                                        "
                                    >
                                        <a-icon
                                            :icon="
                                                group.showPromosOnAcceptView
                                                    ? 'ArrowUp'
                                                    : 'ArrowDown'
                                            "
                                            width="16px"
                                            class="mr-1"
                                        />
                                        Pokaż promocje
                                    </the-btn>
                                    <the-btn
                                        :class="[
                                            group.promosWeight
                                                ? 'btn-secondary'
                                                : 'btn-custom-gray',
                                            {
                                                disabled:
                                                    !group.selectedNoEanPromoIds ||
                                                    group.selectedNoEanPromoIds
                                                        .length === 0
                                            }
                                        ]"
                                        @click.native="
                                            toggleWeightPromos(group)
                                        "
                                        v-tooltip="scaleButtonText(group)"
                                        style="padding-left: 20px; padding-right: 20px"
                                    >
                                        <a-icon icon="Barcode" width="24px" />
                                    </the-btn>
                                    <the-btn
                                        class="btn-custom-gray py-1"
                                        @click.native="onGroupDelete(group)"
                                    >
                                        <a-icon icon="Bin" width="16px" />
                                    </the-btn>
                                </div>
                            </div>
                        </div>
                        <group-merchants
                            v-if="group.showMerchantsOnAcceptView"
                            class="mt-4 mb-3"
                            :group-id="group.id"
                        >
                        </group-merchants>
                        <template v-if="group.showPromosOnAcceptView">
                            <page-preloader
                                v-if="group.promosWeight && group.loaderNoEans"
                            />
                            <div v-else role="promos">
                                <promotion-preview
                                    v-for="(promotion, idx) in groupPromos(
                                        group
                                    )"
                                    :key="`new-${idx}`"
                                    :group-id="group.id"
                                    preview-type="group-accept"
                                    :promotion="promotion"
                                    :acceptance="group.acceptance"
                                    :selected-groups="true"
                                >
                                    <template v-slot:promotionShops>
                                        <alt-ean-disclaimer
                                            v-if="
                                                !promotion.all_eans_present &&
                                                    !$store.getters.hasProductSets(
                                                        promotion.type
                                                    )
                                            "
                                            class="mx-0 mx-md-2 mb-3"
                                        />

                                        <promotion-shops
                                            :group-id="group.id"
                                            :price-group-idx="idx"
                                            :key="promotion.id"
                                            :promotion="promotion"
                                            :merchants="merchants"
                                            :active-promo="promotion.id"
                                            preview-type="group-accept"
                                            @onChangeActivePromo="
                                                activePromo = $event
                                            "
                                            :from-single-promo="true"
                                        ></promotion-shops> </template></promotion-preview>
                            </div>
                        </template>

                        <page-preloader
                            v-if="group.status === 'loading'"
                            min-height="100px"
                        />

                        <the-btn
                            v-if="shouldShowMoreButton(group)"
                            class="btn-custom-gray w-100 mt-3"
                            @click.native="loadMorePromos({ group })"
                        >
                            Pokaż kolejne promocje z grupy
                        </the-btn>
                        <div
                            role="collapse"
                            class="btn-collapse w-100 mt-3 mx-auto d-flex align-items-end"
                            v-if="isBtnCollapseVisible(group)"
                        >
                            <the-btn
                                class="btn-custom-gray w-100 mx-auto"
                                @click.native="collapseGroup(group)"
                            >
                                Zwiń grupę
                            </the-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="step === 2">
            <step-queue @changeStep="step = 3"></step-queue>
        </template>
        <template v-if="step === 3">
            <accept-summary
                ref="acceptSummaryRef"
                modal-id="accept-promo-summary"
            ></accept-summary>
        </template>
        <div v-if="step === 1" class="modal-footer bg-1 border-0 pt-2">
            <the-btn
                @click.native="closeModal(), (step = 1)"
                btn-class="btn-outline btn-block"
                text="Powrót"
            ></the-btn>

            <v-popover
                v-if="showAlternativeEanPopover"
                offset="8"
                class="mt-2 ml-lg-auto ml-0"
                :container="false"
            >
                <the-btn
                    v-tooltip="{
                        content: promoAcceptTooltipContent
                    }"
                    class="btn-activate-promos btn-secondary btn-block"
                    text="Aktywuj wybrane grupy"
                    icon="Promotions"
                    :class="{
                        disabled:
                            pricesErrors ||
                            noSubActive ||
                            getLocalCodesDuplicates.length > 0
                    }"
                ></the-btn>

                <template slot="popover">
                    <popover-confirm
                        message="Aktywujesz promocje, które zawierają produkty z kodem lokalnym.
                            Upewnij się, że kody zostały uzupełnione.
                            W przeciwnym razie promocje mogą nie działać poprawnie."
                        abort-text="Pomiń i aktywuj"
                        confirm-text="Uzupełnij kody"
                        @aborted="activatePromos"
                        @confirmed="showValidatedWeightPromos"
                    />
                </template>
            </v-popover>
            <the-btn
                v-else
                v-tooltip="{
                    content: promoAcceptTooltipContent
                }"
                class="btn-activate-promos btn-secondary btn-block mt-2 ml-lg-auto ml-0"
                id="activate-promos-btn"
                text="Aktywuj wybrane grupy"
                icon="Promotions"
                :class="{
                    disabled:
                        pricesErrors ||
                        noSubActive ||
                        getLocalCodesDuplicates.length > 0
                }"
                @click.native="activatePromos"
            ></the-btn>
        </div>
    </div>
</template>

<script>
import PromotionPreview from '@/components/promotions/promotionsPreview/PromotionPreview'
import AcceptSummary from '@/components/promotions/AcceptSummary'
import PromotionShops from '@/components/promotions/PromotionShops'
import GroupMerchants from '@/components/promotions/GroupMerchants'
import StepQueue from '@/components/promotions/StepQueue'
import AltEanDisclaimer from '@/components/promotions/altEans/AltEanDisclaimer'
import { btnCollapse } from '@/mixins/btnCollapse'

export default {
    mixins: [btnCollapse],
    data() {
        return {
            routeComingFrom: null,
            showInfoAlert: true,
            showShops: false,
            step: 1,
            fromSinglePromo: false,
            activePromo: 0,
            showAlternativeEanPopover: false
        }
    },
    components: {
        StepQueue,
        AcceptSummary,
        PromotionPreview,
        PromotionShops,
        GroupMerchants,
        AltEanDisclaimer
    },

    computed: {
        confirmationWindowConfig() {
            if (
                this.step === 3 &&
                this.$store.getters.getSubscriptionsQueue.accepted.count > 0
            ) {
                return {
                    message: 'Na pewno nie chcesz pobrać cenówek?',
                    abortButtonText: 'Zamknij okno',
                    confirmButtonText: 'Generuj wybrane cenówki',
                    confirmationWindowLoadingText:
                        'Trwa przetwarzanie cenówek. Nie zamykaj okna.',
                    abortButtonCallback: () => {
                        this.$store.dispatch('toggleModal', false)
                    },
                    confirmButtonCallback: () => {
                        this.$refs.acceptSummaryRef.downloadLabels()
                    }
                }
            } else {
                return null
            }
        },
        userMakePriceChanges() {
            const promoItems = []
            this.promoGroups.forEach(promotion => {
                if (promotion.products) {
                    promoItems.push(...promotion.products)
                }

                if (promotion.product_sets) {
                    promoItems.push(...promotion.product_sets)
                }
            })
            return promoItems.some(e => e.priceChange === true)
        },
        promoAcceptTooltipContent() {
            let text = ''
            if (this.noSubActive) {
                // eslint-disable-next-line max-len
                text = 'W co najmniej jednej promocji nie został wybrany żaden sklep. Aby aktywować wybierz sklep lub usuń promocję z koszyka'
            } else if (this.pricesErrors) {
                text =
                    'Co najmniej jeden produkt / zestaw produktów posiada nieprawidłową cenę'
            } else if (this.getLocalCodesDuplicates.length) {
                text =
                    'Co najmniej dwa produkty mają ten sam kod lokalny w sklepie'
            } else if (!this.userMakePriceChanges) {
                // eslint-disable-next-line max-len
                text = 'Klikając przycisk Aktywuj wybrane promocje (bez wcześniejszej edycji ceny przez Ciebie), uruchomisz Promocję w maksymalnej cenie, uprawniającej do otrzymania Zwrotu Kosztów.'
            }
            return text
        },
        accepted() {
            return this.$store.getters.getProcessedSubscriptionByType(
                'accepted'
            )
        },
        total() {
            return this.$store.getters.getProcessedSubscriptionsTotal
        },
        subscriptionsEndMessage() {
            let message = 'Dobrze Ci poszło.'

            const accepted = +this.accepted?.pagination?.totalRecords

            if (this.total !== 0 && accepted === +this.total) {
                message = 'Świetnie!'
            } else if (accepted === 0) {
                message = 'Coś poszło nie tak...'
            }

            return message
        },
        allSubscriptions() {
            return this.$store.getters.getSubscriptionsQueue.all
        },
        merchants() {
            return this.$store.getters.getMerchants
        },
        promoGroups() {
            const promoGroups = this.$store.getters.getSelectedPromoGroups
            promoGroups.forEach(group => {
                group.promos.forEach(promotion => {
                    if (promotion.products) {
                        promotion.products = promotion.products.map(e => {
                            return { ...e, priceChange: false }
                        })
                    }

                    if (promotion.product_sets) {
                        promotion.product_sets = promotion.product_sets.map(
                            e => {
                                return { ...e, priceChange: false }
                            }
                        )
                    }
                })
            })

            return promoGroups
        },
        headerTitle() {
            if (this.step === 2) {
                return 'Aktywowanie promocji'
            } else if (this.step === 3 && this.subscriptionsStatus === 'idle') {
                return this.subscriptionsEndMessage
            } else {
                return 'Aktywacja wybranych promocji'
            }
        },
        subscriptionsStatus() {
            return this.$store.getters.getSubscriptionsStatus
        },
        pricesErrors() {
            return this.$store.getters.getPriceErrors
        },
        noSubActive() {
            return this.$store.getters.atLeastOneOfSelectedPromotionsHasNoSubsActive(
                {
                    promotion: null,
                    state: 'available'
                }
            )
        },
        merchantIds() {
            return this.$store.getters.getSelectedPromoGroup(this.groupId)
                ?.merchantIds
        },
        walkthroughModalPromoAcceptStep() {
            return this.$store.getters.getWalkthroughModalPromoAcceptStep
        },
        isPromoWithEmptyAlternativeEans() {
            const groups = this.selectedGroups
            let isError = false

            for (const group of groups) {
                for (const promo of group.promos) {
                    if (
                        !promo.selected ||
                        this.$store.getters.hasProductSets(promo.type)
                    ) {
                        continue
                    }

                    for (const sub of promo.subscriptions) {
                        if (sub.state === 'available' && !sub.suspended) {
                            isError =
                                !!this.$store.getters.getLocalCodesErrors.find(
                                    el =>
                                        el.type === 'emptyEan' &&
                                        sub.id === el.subscriptionId
                                ) ||
                                !!this.$store.getters.getLocalCodesErrors.find(
                                    el =>
                                        el.type === 'noProducts' &&
                                        sub.id === el.subscriptionId
                                )
                            if (isError) break
                        }
                    }
                }
            }
            return isError
        },

        areUnloadedWeightTypePromos() {
            const unloadedNoEansPromos = []

            for (const group of this.selectedGroups) {
                const loadedPromos = group.promos
                    .filter(promo => promo.selected)
                    .map(promo => promo.id)

                for (const noEanPromo of group.selectedNoEanPromoIds) {
                    if (!loadedPromos.includes(noEanPromo)) {
                        unloadedNoEansPromos.push(noEanPromo)
                    }
                }
            }

            return !!unloadedNoEansPromos.length
        },
        selectedGroups() {
            return this.$store.getters.getSelectedPromoGroups
        },
        availableMerchants() {
            return this.$store.getters.getAvailableMerchants
        },
        filterSelectedMerchants() {
            return this.$store.getters.getPromotionsFilters[
                'promo|subscription|merchant_id'
            ].value
        },
        getLocalCodesDuplicates() {
            return this.$store.getters.getLocalCodesDuplicates
        }
    },
    watch: {
        walkthroughModalPromoAcceptStep: {
            immediate: true,
            handler(val) {
                if (this.$store.getters.getWalkthroughActive) {
                    this.step = val
                }
            }
        },
        promoGroups: {
            immediate: true,
            deep: true,
            handler() {
                if (!this.$store.getters.getWalkthroughActive) {
                    this.showAlternativeEanPopover =
                        this.isPromoWithEmptyAlternativeEans ||
                        this.areUnloadedWeightTypePromos
                }
            }
        },
        selectedGroups() {
            this.onHandleBtnCollapse()
        }
    },
    methods: {
        onGroupDelete(group) {
            this.$store.dispatch('openConfirmationWindow', {
                message: 'Czy na pewno chcesz usunąć całą grupę z aktywacji?',
                abortButtonText: 'Zamknij okno',
                confirmButtonText: 'Usuń grupę',
                confirmButtonCallback: async () => {
                    await this.$store.dispatch('selectPromoGroup', {
                        groupId: group.id,
                        select: false
                    })
                    if (
                        this.$store.getters.getSelectedPromoGroups.length === 0
                    ) {
                        this.$store.dispatch('toggleModal', false)
                    }
                }
            })
        },
        loadMorePromos({ group, setPer, setPage }) {
            const { pagination } = group
            let { perPage: per, page } = pagination

            // Check if initial 2 promos are already loaded
            const isInitial =
                +pagination.perPage === 2 && +pagination.nextPage === 2

            if (!setPer) {
                // If initial 2 promos are loaded, set per to 100
                per = isInitial ? 100 : per
            }

            if (!setPage) {
                page = pagination.nextPage || 1
            }

            this.$store.dispatch('loadSelectedPromos', {
                group,
                per,
                page,
                params: {
                    id: group.selectedPromoIds.join(',')
                }
            })
        },
        async onShowHidePromosClick(group) {
            group.showPromosOnAcceptView = !group.showPromosOnAcceptView
            group.showMerchantsOnAcceptView = false

            const selectedPromos = group.promos.filter(promo => promo.selected)

            if (
                !this.$store.getters.getWalkthroughActive &&
                group.showPromosOnAcceptView &&
                !selectedPromos.length
            ) {
                await this.loadMorePromos({ group, setPer: 2, setPage: 1 })
            }
        },
        async onShowHideMerchantsClick(group) {
            this.downloadGroupMerchants(group)
            group.showMerchantsOnAcceptView = !group.showMerchantsOnAcceptView
            group.showPromosOnAcceptView = false
        },
        async downloadGroupMerchants(group) {
            this.$store.dispatch('downloadGroupMerchants', group)
        },
        getGroupSelectedPromos(group) {
            return group.promos.filter(promo =>
                group.selectedPromoIds.includes(promo.id)
            )
        },
        async deselectAllUnavailableShops() {
            await this.$store.dispatch('merchantsFetch')
            const availableStates = ['active', 'during_installation', 'during_termination']
            const merchants = this.merchants || []
            const selectedGroups = this.$store.getters.getSelectedPromoGroups || []

            for (const group of selectedGroups) {
                const groupMerchantIds = group.merchantIds || []

                for (const groupMerchant of groupMerchantIds) {
                    const merchant = merchants.find(
                        merchant => merchant.id === groupMerchant.id
                    )

                    if (!merchant || !availableStates.includes(merchant.state)) {
                        // If merchant is not available, deselect it
                        this.$store.dispatch('selectGroupMerchant', {
                            merchantId: merchant.id,
                            groupId: group.id,
                            value: false
                        })
                    }
                }
            }
        },
        async activatePromos() {
            if (
                !this.pricesErrors &&
                !this.noSubActive &&
                !this.getLocalCodesDuplicates.length
            ) {
                await this.deselectAllUnavailableShops()
                this.step = 2
                this.$store.dispatch('subscriptionsQueue', {
                    state: 'accepted'
                })
            }
        },
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        historyGoBack() {
            if (performance.navigation.type === 1) {
                history.pushState({}, null, this.routeComingFrom)
            }
        },
        async toggleWeightPromos(group) {
            if (!group.selectedNoEanPromoIds?.length) {
                return
            }

            if (!group.showPromosOnAcceptView) {
                group.showPromosOnAcceptView = !group.showPromosOnAcceptView
            }

            await this.$store.dispatch('toggleWeightPromos', {
                group,
                params: {
                    promo_group_id: group.id
                }
            })
        },
        groupPromos(group) {
            if (group.promosWeight) {
                return this.getGroupSelectedPromos(group).filter(
                    promo => !promo.all_eans_present
                )
            } else {
                return this.getGroupSelectedPromos(group).filter(
                    promo => promo.main_set
                )
            }
        },
        scaleButtonText(group) {
            const areWeightPromos = group.selectedNoEanPromoIds?.length

            if (!areWeightPromos) {
                return 'W tej grupie nie ma żadnej promocji z kodami lokalnymi'
            } else {
                if (group.promosWeight) {
                    return 'Pokaż wszystkie promocje'
                } else {
                    return 'Pokaż tylko promocje z kodami lokalnymi'
                }
            }
        },
        async showValidatedWeightPromos() {
            this.$store.commit('SET_LOCALCODES_VALIDATION', false)
            const fetchProducts = async (group, promo) => {
                const res = await this.$store.dispatch(
                    'fetchProductsByPromoGroupPromo',
                    {
                        promoId: promo.id,
                        groupId: group.id,
                        main: true,
                        fromSelectedGroups: this.selectedGroups
                    }
                )
                if (!promo.all_eans_present) {
                    await this.$store.dispatch(
                        'setMerchantEansInSelectedPromoGroup',
                        {
                            products: res,
                            promotion: promo,
                            params: {
                                per: 99999
                            }
                        }
                    )
                }
                return res
            }
            const showDetails = async (group, promo) => {
                group.showPromosOnAcceptView = true
                this.$set(promo, 'showMore', true)
            }

            // deselect all weight buttons & fetch all weight promos
            for (const group of this.selectedGroups) {
                group.showMerchantsOnAcceptView = false
                group.promosWeight = false
                await this.toggleWeightPromos(group)
            }

            // fetch products
            for (const group of this.selectedGroups) {
                for (const promo of group.promos) {
                    if (promo.selected && promo.type.includes('Weight')) {
                        if (
                            !promo.products?.length &&
                            !promo.product_sets.length
                        ) {
                            await fetchProducts(group, promo)
                        }
                    }
                }
            }

            const groups = this.selectedGroups

            // check and expand all weight promos with empty codes
            for (const group of groups) {
                for (const promo of group.promos) {
                    if (promo.selected && promo.type.includes('Weight')) {
                        for (const sub of promo.subscriptions) {
                            if (sub.checked) {
                                const areProducts = sub.products.length
                                const findEmptyCode = sub.products.find(
                                    product => !product.alternativeEan
                                )
                                if (!areProducts || findEmptyCode) {
                                    await showDetails(group, promo)
                                }
                            } else {
                                await showDetails(group, promo)
                            }
                        }
                    }
                }
            }
            this.$store.commit('SELECT_PROMOGROUP', groups)

            setTimeout(() => {
                const changePrices = document.querySelectorAll('.change-price')
                changePrices.forEach(changePrice => {
                    const comp = changePrice.__vue__
                    if (!comp.localCode) {
                        comp.isLocalCodeInvalid = true
                    }
                })
            }, 0)
            this.$store.commit('SET_LOCALCODES_VALIDATION', true)
        },
        shouldShowMoreButton(group) {
            const selectedPromos = group.promos.filter(el => el.selected)
            return (
                selectedPromos.length < group.selectedPromoIds.length &&
                group.showPromosOnAcceptView &&
                !group.promosWeight
            )
        },
        collapseGroup(group) {
            group.showPromosOnAcceptView = false
        },
        onHandleBtnCollapse() {
            document.querySelectorAll('.t-promo-group').forEach(el => {
                this.handleBtnCollapse(el)
            })
        }
    },
    beforeDestroy() {
        this.$store.commit('SET_LOCALCODES_VALIDATION', false)
        if (this.$store.getters.getWalkthroughActive) {
            return
        }
        history.pushState({}, null, this.routeComingFrom)
        this.$store.dispatch('setSubscriptionsStatus', 'idle')
        this.$store.dispatch('clearQueue')
        this.$store.dispatch('setUnloadedWeightPromos', [])
        if (this.step === 3) {
            this.$store.dispatch('clearSelectedPromoGroups')
        }
    },
    async mounted() {
        const singlePromo = document.querySelector('#single-promo')
        if (singlePromo) {
            this.fromSinglePromo = false
        }

        // fetch all groups merchants
        for (const group of this.selectedGroups) {
            await this.downloadGroupMerchants(group)
        }

        this.onHandleBtnCollapse()

        const modalContent = document.querySelector(
            '.modal--accept .modal-body'
        )

        modalContent.addEventListener('scroll', () => {
            this.onHandleBtnCollapse()
        })
    },
    created() {
        history.pushState({}, null, '/cart')
        this.routeComingFrom = this.$route.fullPath
        this.$store.dispatch('checkPricesErrors')
    }
}
</script>
